export default __webpack_public_path__ + "static/media/logomotoexplorer.f853dd9b.jpg";